export const GisDataActionTypes = {
  SET_AUTO_SUGGESTION: "SET_AUTO_SUGGESTION",
  UPDATE_SUGGESTION_CATEGORY: "UPDATE_SUGGESTION_CATEGORY",
  UPDATE_SEARCH_RESULT: "UPDATE_SEARCH_RESULT",
  SET_ROUTING_SOURCE: "SET_ROUTING_SOURCE",
  SET_ROUTING_DESTINATION: "SET_ROUTING_DESTINATION",
  SET_ROUTING_PATH: "SET_ROUTING_PATH",
  SET_MAP_PIN_TYPE: "SET_MAP_PIN_TYPE",
};
